import React, {memo} from 'react';
import PropTypes from 'prop-types';

export const  VideoPlayIcon = memo(({ fillColor = '#FFFFFF', strokeColor = '#FFFFFF', width = 30, height = 30 }) =>
    <svg viewBox='-1 -1 62 62' width={width} height={height} fill={fillColor} stroke={strokeColor} version='1.1' xmlns='http://www.w3.org/2000/svg'>
        <circle id='Oval-79' fill='none' strokeWidth='2' cx='30' cy='30' r='30'></circle>
        <path d='M38.5328794,30.2733123 C39.2299967,30.6746508 39.2278669,31.3265753 38.5328794,31.7266877 L25.6329743,39.1533123 C24.935857,39.5546508 24.3707317,39.2479122 24.3707317,38.4715576 L24.3707317,23.5284424 C24.3707317,22.7505811 24.9379868,22.4465753 25.6329743,22.8466877 L38.5328794,30.2733123 L38.5328794,30.2733123 Z' id='Triangle-4' strokeWidth='0'></path>
    </svg>
);

VideoPlayIcon.displayName = 'VideoPlayIcon';

VideoPlayIcon.propTypes = {
    fillColor: PropTypes.string,
    strokeColor: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
};
